const module = {
  routes: [
    {
      // ИД journal of one request (ТЗ, п. 9)
      path: '/rebroadcasts-history-data/:id/journal',
      component: () => import('@/modules/rebroadcastsHD/pages/journal.vue'),
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    },
    {
      path: '/rebroadcasts-history-data',
      component: () => import('@/modules/rebroadcastsHD/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
